import _ from 'lodash';
import React from 'react';
import i18next from 'i18next';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import CalculatorStandardInput from '../../../../calculatorInputs/CalculatorStandardInput';

const EqualValue = ({ validateValue, availableValueOptions, showLabel, fieldName, readOnly = false }) => {
  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';
  const placeholder = i18next.t('calculator.dialog.create.placeholder.selectValues');

  const commonProps = {
    fieldName: `${fieldName}.0`,
    label,
    placeholder,
    isRequired: true,
    uxVariant: 'criteriaInput',
    variant: 'standard',
    validate: validateValue,
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorSelectInput
      {...commonProps}
      options={availableValueOptions}
      labelVariant="chip"
      triggerOnContinue
      disabled={readOnly}
    />
  ) : (
    <CalculatorStandardInput {...commonProps} triggerOnContinue disabled={readOnly}/>
  );
};

export default EqualValue;
